import { Button } from "@bounce/design-system"
import { useTranslation } from "@bounce/i18n"

type StoreListSectionLoadingProps = {
  onClear: () => void
}

export const StoreListSectionLoading = ({ onClear }: StoreListSectionLoadingProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className="text-center">
        <h3 className="mb-2 text-lg font-semibold text-neutral-800">
          {t("screen.storeList.noResults.title", "No storage locations found")}
        </h3>
        <p className="mb-6 text-secondary-600">
          {t("screen.storeList.noResults.description", "Try adjusting your filters or search criteria")}
        </p>
        <Button variant="secondary" onPress={onClear}>
          {t("screen.storeList.noResults.clearFilters", "Clear filters")}
        </Button>
      </div>
    </div>
  )
}
